import {
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';

import { get } from '../../../utils/request';
import makeSelectMain from '../../Main/selectors';
import {
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_ERROR_MESSAGE,
  FETCH_TRANSACTION_DETAIL,
  FETCH_TRANSACTION_DETAIL_ERROR_MESSAGE,
} from './constants';
import {
  fetchTransactionDetailFailure,
  fetchTransactionDetailSuccess,
  fetchTransactionsFailure,
  fetchTransactionsSuccess,
} from './actions';
import makeSelectPaymentHistory from './selectors';

export function* fetchTransactionsSaga({ baseUrl }) {
  try {
    const pageToFetch = yield select(makeSelectPaymentHistory('pageToFetch'));
    // if pageToFetch is -1, all pages have already been fetched
    if (pageToFetch !== -1) {
      const loanNumber = yield select(makeSelectMain('selectedLoan'));
      const itemsPerPage = yield select(makeSelectPaymentHistory('itemsPerPage'));
      const queryParams =
        `itemsPerPage=${itemsPerPage}&pageToFetch=${pageToFetch}&transactionType=history`;
      const endPoint = `${baseUrl}/transactions/${loanNumber}?${queryParams}`;
      const { page, totalPages, transactions } = yield call(get, endPoint);
      yield put(fetchTransactionsSuccess(page, totalPages, transactions));
    }
  } catch (error) {
    yield put(fetchTransactionsFailure(FETCH_TRANSACTIONS_ERROR_MESSAGE));
  }
}

export function* fetchTransactionDetailSaga({ baseUrl }, { payload }) {
  try {
    const { transactionId } = payload;
    const loanNumber = yield select(makeSelectMain('selectedLoan'));
    const queryParams = `transactionId=${transactionId}`;
    const endPoint = `${baseUrl}/transactions/detail/${loanNumber}?${queryParams}`;
    const { error, transaction } = yield call(get, endPoint);
    if (error) {
      yield put(fetchTransactionDetailFailure(FETCH_TRANSACTION_DETAIL_ERROR_MESSAGE));
    } else {
      yield put(fetchTransactionDetailSuccess(transaction));
    }
  } catch (error) {
    yield put(fetchTransactionDetailFailure(FETCH_TRANSACTION_DETAIL_ERROR_MESSAGE));
  }
}

export default (options) => function* watcherSaga() {
  yield all([
    takeLatest(FETCH_TRANSACTION_DETAIL, fetchTransactionDetailSaga, options),
    takeLatest(FETCH_TRANSACTIONS, fetchTransactionsSaga, options),
  ]);
};
